export default __webpack_public_path__ + "static/media/placeholder.053e5d70.svg";